import { render, staticRenderFns } from "./OportunityTopArea.vue?vue&type=template&id=7230d45d&"
import script from "./OportunityTopArea.vue?vue&type=script&lang=js&"
export * from "./OportunityTopArea.vue?vue&type=script&lang=js&"
import style0 from "./OportunityTopArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports